import { getPlanRate } from '@frameio/plan-management/plans/utils/getPlanRate';

export const getMemberSeatRateLabel = ({
  canShowRate,
  planPeriod,
  subscriptionCost,
}: {
  canShowRate?: boolean;
  planPeriod?: string | null;
  subscriptionCost?: number | null;
}): string => {
  if (
    !canShowRate ||
    typeof subscriptionCost !== 'number' ||
    subscriptionCost <= 0 ||
    !planPeriod
  ) {
    return '';
  }

  return getPlanRate(planPeriod, subscriptionCost);
};
